import { Model } from "pinia-orm";

export default class Tag extends Model {
  static entity = "tags";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.attr(null),
      slug: this.attr(null),
    };
  }
}
